import { useState, useEffect } from "react";

/**
 * Fetches the top Karol operational recommendation (read-only).
 * Fail-closed: any error or disabled flag → null.
 */
export function useKarolOperationalInsight(authAxios, restaurantId, { enabled = true } = {}) {
  const [recommendation, setRecommendation] = useState(null);
  const [generatedAt, setGeneratedAt] = useState(null);

  useEffect(() => {
    if (!enabled || !authAxios || !restaurantId) {
      setRecommendation(null);
      setGeneratedAt(null);
      return undefined;
    }

    let cancelled = false;

    authAxios
      .get(`/karol/insights/${restaurantId}/top-recommendation`)
      .then((res) => {
        if (cancelled) return;
        const data = res.data;
        if (
          !data?.operational_ui_enabled ||
          !data?.karol_enabled ||
          !data?.recommendation?.title
        ) {
          setRecommendation(null);
          setGeneratedAt(null);
          return;
        }
        setRecommendation(data.recommendation);
        setGeneratedAt(data.generated_at ?? null);
      })
      .catch((err) => {
        // Fail-closed: 403 (non-owner / flag off) and any other error → null, no retry.
        if (!cancelled) {
          setRecommendation(null);
          setGeneratedAt(null);
        }
        if (process.env.NODE_ENV === "development" && err?.response?.status !== 403) {
          console.debug("[Karol] top-recommendation fetch error", err?.response?.status);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [authAxios, restaurantId, enabled]);

  return { recommendation, generatedAt };
}
